import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "status-bar"
};
const _hoisted_2 = {
  class: "status-bar__container"
};
const _hoisted_3 = {
  class: "status-bar__desktop"
};
const _hoisted_4 = {
  class: "status-bar__header-indicator"
};
const _hoisted_5 = {
  key: 0,
  class: "status-bar__step-header-line"
};
const _hoisted_6 = {
  class: "status-bar__step-number"
};
const _hoisted_7 = {
  class: "status-bar__step-title"
};
const _hoisted_8 = {
  class: "status-bar__mobile"
};
const _hoisted_9 = {
  key: 0,
  class: "status-bar__step-header-line"
};
const _hoisted_10 = {
  class: "status-bar__step-number"
};
const _hoisted_11 = {
  class: "status-bar__step-title2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.steps, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index + 1,
      class: _normalizeClass(["status-bar__step-header", {
        active: index + 1 <= $options.currentStep,
        start: index === 0,
        end: index + 1 === $props.steps.length,
        current: item.status
      }])
    }, [_createElementVNode("div", _hoisted_4, [index > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(index + 1), 1)]), _createElementVNode("div", _hoisted_7, _toDisplayString($options.getI18nMessage(item.title)), 1)])], 2);
  }), 128))]), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.steps, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index + 1,
      class: _normalizeClass(["status-bar__step-header2", {
        active: index + 1 <= $options.currentStep,
        start: index === 0,
        end: index + 1 === $props.steps.length,
        current: item.status
      }])
    }, [index > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(index + 1), 1)]), _createElementVNode("div", _hoisted_11, _toDisplayString($options.getI18nMessage(item.title)), 1)], 2);
  }), 128))])])]);
}